import { SiteUrls } from '@tableau/shared-urls';
import { appStore } from '../../app/AppStore';
import {
  addContentTypeToProjectHierarchy,
  populateContentBreadcrumbs,
  watchUrlForBreadcrumbUpdates
} from '../../app/content/breadcrumbs/BreadcrumbHelpers';
import { IPlaceScope } from '../../app/IPlaceScope';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { DataRoleSpaceOwnProps } from '../../dataRole/components/DataRoleSpace';
import { AngularContextFactory } from '../factories/AngularContextFactory';
import { ISubplaceTabsScope } from '../helpers/SubplaceCountsHelper';
import { isDataRolePlacePath } from '../helpers/UrlHelpers';
import { IDataRoleDetailInfo, IDataRoleInfo } from '../models/IDataRoleInfo';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { IDataRoleActions } from '../ServerApi/types/IDataRoleActions';
import { ServerService } from '../services/ServerService';
import { Telemetry } from '../services/TelemetryService';


export type DataRolePlaceScope =
IPlaceScope &
ISubplaceTabsScope &
{
  dataRoleSpaceOwnProps: DataRoleSpaceOwnProps;
};

export class DataRolePlaceCtrl {
  public static $inject = [
    'AngularContextFactory',
    '$location',
    '$scope',
    '$state',
    '$translate',
    'ServerService',
    'TelemetryService',
    'dataRoleAllowedActions',
    'dataRoleDetailInfo',
    'dataRoleListItemInfo',
    'projectHierarchy',
  ];

  constructor(
    angularContextFactory: AngularContextFactory,
    private $location: ng.ILocationService,
    private $scope: DataRolePlaceScope,
    private $state: ng.ui.IStateService,
    private $translate: ng.translate.ITranslateService,
    ServerService: ServerService,
    TelemetryService: Telemetry,
    dataRoleAllowedActions: IDataRoleActions,
    dataRoleDetailInfo: IDataRoleDetailInfo,
    private dataRoleListItemInfo: IDataRoleInfo,
    private projectHierarchy: INamedItemInfo[],
  ) {
    const angularContext = angularContextFactory.create($scope);

    const siteUrls = new SiteUrls({
      siteUrlName: ServerService.sessionSiteUrlName(),
      queryString: window.location.search,
    });

    $scope.dataRoleSpaceOwnProps = {
      allowedActions: dataRoleAllowedActions,
      dataRoleDetailInfoWithUsage: {
        usageInfo: dataRoleListItemInfo.usageInfo,
        usageInfoMaxValues: dataRoleListItemInfo.usageInfoMaxValues,
        ...dataRoleDetailInfo,
      },
      subspaceName: 'definition',
      subspaceProps: {
        angularContext: angularContext,
        siteUrls: siteUrls,
        dataRoleDetailInfo: dataRoleDetailInfo,
        translate: this.$translate.instant,
      },
      telemetry: TelemetryService,
      angularContext: angularContext,
    };

    this.initBreadcrumbsOnScope();
  }

  private initBreadcrumbsOnScope() {
    const projectHierarchyWithType = addContentTypeToProjectHierarchy(this.projectHierarchy);
    const siteUrls = siteUrlsSelector(appStore.getState());
    populateContentBreadcrumbs([ ...projectHierarchyWithType, this.dataRoleListItemInfo ], siteUrls);
    watchUrlForBreadcrumbUpdates(this.$scope, this.$location,
      () => isDataRolePlacePath(this.dataRoleListItemInfo.id, this.$location.path()));
  }
}
